import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Axios from 'axios'
import Vuelidate from 'vuelidate'
Vue.config.productionTip = false

Vue.use(Vuelidate)

Vue.use(Axios)
Axios.defaults.baseURL = '"https://localhost:5001"'
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
